// react
import React, { forwardRef } from 'react';

// css
import './icon.scss';

/**
 * icon
 */
export const Icon = forwardRef((props, ref) => {
  const { class: classes, className = '', ...otherProps } = props;
  const baseClassName = className.includes('shk-') ? 'shakkerfont' : 'liblibfont';

  return (
    <i
      {...otherProps}
      ref={ref}
      className={`${baseClassName} ${classes || className}`}
      style={{ color: props.color, fontSize: props.fontSize, lineHeight: props.lineHeight }}
    ></i>
  );
});
